import types from './types';
import update from '../../../../utilities/updateStateUtilities';
import { EXPORT_STATUSES } from '../../../../constants/ExportStatuses';

const INITIAL_STATE = {
    loadingVideos: false,
    appendingVideos: false,
    showMoreVideos: true,
    videos: [],
    videosFresh: false,

    searchingVideos: false,
    // The phrase the loaded videos are filtered by, not the text currently typed in the search field.
    searchPhrase: '',

    videoExpirationDialog: {
        dialogOpen: false,
        videoThumbnail: null,
        expirationDays: 0
    }
}

const videoReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case types.SET_PROPERTY: {
            return update.set(state, action.key, action.value);
        }
        
        case types.SET_LOADING_VIDEOS: {
            return {
                ...state,
                loadingVideos: action.loading
            }
        }
        case types.UPDATE_VIDEOS: {
            return {
                ...state,
                videos: action.videos
            }
        }
        case types.SET_APPENDING_VIDEOS: {
            return {
                ...state,
                appendingVideos: action.appending
            }
        }
        case types.APPEND_VIDEOS: {
            return {
                ...state,
                videos: state.videos.concat(action.videos)
            }
        }

        case types.SET_SHOW_MORE_VIDEOS: {
            return {
                ...state,
                showMoreVideos: action.show
            }
        }

        case types.SET_SEARCHING_VIDEOS: {
            return {
                ...state,
                searchingVideos: action.searching
            }
        }

        case types.SET_SEARCH_PHRASE: {
            return {
                ...state,
                searchPhrase: action.searchPhrase
            }
        }

        case types.SET_VIDEOS_FRESH: {
            return {
                ...state,
                videosFresh: action.fresh
            }
        }

        case types.REMOVE_VIDEO_ITEM: {
            const modifiedVideos = state.videos.filter(video => video.id !== action.videoId);
            return update.set(state, `videos`, modifiedVideos ? modifiedVideos.slice() : []);
        }

        case types.REMOVE_VIDEO_EXPORT: {
            if (state.videos && state.videos.length) {
                const targetVideo = state.videos.filter(video => video.id === action.videoId)[0];

                if (targetVideo && targetVideo.exports && targetVideo.exports.length) {
                    const modifiedVideos = state.videos.slice();

                    const videoIndex = state.videos.indexOf(targetVideo);
                    const modifiedExports = targetVideo.exports.filter(exp => exp.exportId !== action.exportId);

                    modifiedVideos[videoIndex].exports = modifiedExports ? modifiedExports.slice() : [];
                    return update.set(state, `videos`, modifiedVideos);
                }
            }

            return state;
        }

        case types.UPDATE_EXPORT_PROGRESS: {
            const { videoId, exportId, progress } = action;
            const targetScope = findVideoExportHierarchicalScope(state.videos, videoId, exportId);

            if (targetScope) {
                const modifiedVideos = state.videos.slice();
                const updatedVideoExport = {  ...targetScope.targetExport, progress: progress };

                if (progress.step)
                    updatedVideoExport.status = EXPORT_STATUSES.RUNNING;
                
                modifiedVideos[targetScope.targetVideoIndex].exports[targetScope.targetExportIndex] = updatedVideoExport;
                return update.set(state, `videos`, modifiedVideos);
            }
            return state;
        }

        case types.SET_EXPORT_STATUS: {
            const { videoId, exportId, status } = action;
            const targetScope = findVideoExportHierarchicalScope(state.videos, videoId, exportId);

            if (targetScope && targetScope.targetExport.status !== status) {
                const modifiedVideos = state.videos.slice();

                modifiedVideos[targetScope.targetVideoIndex].exports[targetScope.targetExportIndex] = { 
                    ...targetScope.targetExport, 
                    status: status 
                };
                return update.set(state, `videos`, modifiedVideos);
            }
            return state;
        }

        default: return state;
    }
}

// The small helper get the necessary data to update an export.
const findVideoExportHierarchicalScope = (videos, videoId, exportId) => {
    if (!videos || !videos.length)
        return null;

    const targetVideo = videos.filter(video => video.id === videoId)[0];
    if (!targetVideo || !targetVideo.exports || !targetVideo.exports.length)
        return null;

    const targetExport = targetVideo.exports.filter(exp => exp.exportId === exportId)[0];
    if (!targetExport)
        return null;

    return {
        targetVideo: targetVideo,
        targetVideoIndex: videos.indexOf(targetVideo),
        targetExport: targetExport,
        targetExportIndex: targetVideo.exports.indexOf(targetExport)
    };
}

export default videoReducer;